import { ColumnConfiguration, GridData, ValueOption } from '../table';

export type Worklist = {
  id: number;
  status?: ValueOption;
  lastNote: string;
  lastNoteUpdatedDate: Date;
  practice: string;
  data: Record<string, string | number>;
  isNew: boolean;
  isTerminalState: boolean;
  followUpDate?: string;
  assignedTo?: string;
  reevaluationDate?: string;
  lastContactWithSiteDate?: string;
  notificationSentDate?: string;
  enterIntoLink?: boolean;
};

export type WorklistV2 = {
  worklistID: number;
  worklistDescr: string;
  worklistHeader?: string;
  reportUrl?: string;
};

export type WorklistResponse = {
  columns: ColumnConfiguration[];
  rows: Worklist[];
};

export const convertWorklistToGridData = (
  worklistResponse: WorklistResponse
): GridData => {
  const rows = worklistResponse.rows.map(row => ({
    id: row.id,
    ...row.data,
    status: row.status,
    lastNote: row.lastNote,
    lastNoteUpdatedDate: row.lastNoteUpdatedDate,
    practice: row.practice,
    isTerminalState: row.isTerminalState,
    followUpDate: row.followUpDate,
    assignedTo: row.assignedTo,
    reevaluationDate: row.reevaluationDate,
    lastContactWithSiteDate: row.lastContactWithSiteDate,
    notificationSentDate: row.notificationSentDate,
    enterIntoLink: row.enterIntoLink,
  }));

  worklistResponse.columns.unshift({
    name: 'actions',
    type: 'actions',
    displayName: 'Actions',
    width: 120,
    cellClassName: 'actions',
    required: true,
    editable: false,
    defaultValue: '',
  });

  return {
    columns: worklistResponse.columns,
    rows,
  };
};
